<script>
    import messages from "/core/stores/alertsStore.js";

    import SuccessAlert from "./SuccessAlert.svelte";
    import InfoAlert from "./InfoAlert.svelte";
    import WarningAlert from "./WarningAlert.svelte";
    import DangerAlert from "./DangerAlert.svelte";

    import { fly,scale } from 'svelte/transition';

    function handleCancelAlert(event) {
        messages.deleteByHash(event.detail.hash);
    }

</script>

{#if $messages.length > 0}

    <div class='row'>
        <div class='col-sm-12 col-md-6 offset-md-6'>
            <section class="alerts-container-box position-fixed bottom-0 end-0 mb-1 me-1 ms-1">
                {#each $messages as m}

                    {#if m.type == 'success'}
                        <div in:scale|global out:fly|global>

                            <SuccessAlert msg={m} on:cancelalert={handleCancelAlert}/>

                        </div>
                    {/if}

                    {#if m.type == 'info'}

                        <div in:scale|global out:fly|global>

                            <InfoAlert msg={m} on:cancelalert={handleCancelAlert}/>

                        </div>

                    {/if}
                    {#if m.type == 'warning'}

                        <div in:scale|global out:fly|global>
                            
                            <WarningAlert msg={m} on:cancelalert={handleCancelAlert}/>

                        </div>

                    {/if}
                    {#if m.type == 'danger'}

                        <div in:scale|global out:fly|global>
                            
                            <DangerAlert msg={m} on:cancelalert={handleCancelAlert}/>

                        </div>
                        
                    {/if}
                {/each}
            </section>
        </div>
    </div>

{/if}

<style>
    .alerts-container-box {
        z-index: 10000;
        min-width: 400px;            
        background: rgba(217, 222, 222,.25)
    }
</style>